export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5467.4bb245d3.jpg";